import React, { Fragment } from "react";
import { Seo, Breadcrumb, ScrollTopBtn,Button } from "../components";
import { HeaderThree, BlogThree, FooterTwo } from "../containers";

const BlogGrid = () => (
  <Fragment>
    <Seo
      title="Tech Ayukta Blogs Grid View — Insights on Technology, ERP, and Digital Transformation"
      description="Explore the latest blogs from Tech Ayukta covering ERP solutions, custom software, web & mobile app development, IT consulting, and digital transformation strategies for modern businesses."
      keywords="Tech Ayukta Blog, ERP Solutions, IT Consulting, Web Development, Mobile App Development, Custom Software, Digital Transformation, Business Automation, Technology Insights"
      canonical="https://www.techayukta.com/blog-grid"
    />
    <HeaderThree />
    <Breadcrumb
      pageName="Blog Grid"
      bgImage="/images/breadcumb/breadcumb-bg.jpg"
    />
    <div className="container mt-3 d-none d-md-block">
      <Button path="/blog">
        Blog Block View
        <i className="far fa-arrow-right" />
      </Button>
    </div>
    <BlogThree className="space-top space-extra-bottom pt-5 pt-md-2" />
    <FooterTwo />
    <ScrollTopBtn />
  </Fragment>
);

export default BlogGrid;
